import styled from "styled-components";
import { fonts, colors, sizing } from "../../../styles/variables.js";

export const Projects = styled.div``;

export const Project = styled.div`
   display: flex;
   justify-content: space-between;
   padding: 3rem 0;
   margin-top: 1rem;

   @media (max-width: 1000px) {
      flex-direction: column-reverse;
      width: 80%;
      margin: 2rem auto 0;
   }

   @media (max-width: 700px) {
      width: 90%;
   }

   @media (max-width: 500px) {
      margin: 1rem auto 0;
   }
`;

export const ProjectMain = styled.div`
   flex: 1.1;
   margin-right: 2.8rem;

   @media (max-width: 1000px) {
      margin-top: 4.4rem;
      margin-right: 0;
   }
`;

export const ProjectNum = styled.h1`
   font-family: ${fonts.num};
   font-size: 3.8rem;
   font-weight: 900;
   color: ${colors.secondary1};
`;

export const ProjectTags = styled.div`
   display: flex;

   @media (max-width: 500px) {
      flex-wrap: wrap;
   }
`;

export const ProjectActions = styled.div`
   display: flex;
   align-items: center;
`;

export const ProjectImg = styled.div`
   width: 28rem;
   align-self: center;

   @media (max-width: 700px) {
      width: 80%;
   }

   @media (max-width: 500px) {
      width: 90%;
   }
`;

export const ImagesGroup = styled.div`
   position: relative;

   .desktop {
      width: 80%;
      margin-left: auto;
      border-radius: ${sizing.borderRadius4};
      box-shadow: 0 4px 16px #dfdfdf;

      @media (max-width: 700px) {
         margin-right: 1rem;
      }

      img {
         width: 100%;
      }
   }

   .url-shortner-desktop {
      height: 14rem;

      @media (max-width: 500px) {
         width: 90%;
         margin-right: 0;
      }

      @media (max-width: 450px) {
         height: 11rem;
      }
   }

   .mobile {
      position: absolute !important; /* becoz there is default styling on element */
      bottom: -1rem;
      left: 2rem;
      width: 10rem;
      height: 18rem;
      border-radius: ${sizing.borderRadius4};
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);

      @media (max-width: 700px) {
         left: 1rem;
         width: 8rem;
         height: 14rem;
      }

      @media (max-width: 400px) {
         width: 5.5rem;
         height: 10rem;
      }

      img {
         width: 100%;
         object-position: center 0 !important;
      }
   }

   .url-shortner-mobile {
      width: 8rem;
      height: 13rem;
      left: 1rem;

      @media (max-width: 700px) {
         left: 0;
         width: 7rem;
         height: 11rem;
      }

      @media (max-width: 450px) {
         width: 5.2rem;
         height: 9rem;
      }

      img {
         object-position: center !important;
      }
   }
`;
